import React, { useEffect } from 'react';
import { useStudentGet } from 'actions/studentsv2';
import PropTypes from 'prop-types';

import AssignTeacherModal from './student-demo/assign-teacher';

const AssignTeacherModalContainer = ({
  formType,
  data: { studentId, mappingLogId },
  programs,
}) => {
  const { data: studentDetail, get: getStudent } = useStudentGet();

  useEffect(() => {
    getStudent(studentId);
  }, [studentId, getStudent]);

  return (
    <AssignTeacherModal
      formType={formType}
      data={{
        ...studentDetail,
        mappingLogId,
      }}
      programs={programs}
    ></AssignTeacherModal>
  );
};
AssignTeacherModalContainer.propTypes = {
  programs: PropTypes.array.isRequired,
  tokboxDownCountryCode: PropTypes.shape({}),
  formType: PropTypes.string.isRequired,
  data: PropTypes.shape({
    studentId: PropTypes.string.isRequired,
    mappingLogId: PropTypes.string.isRequired,
  }),
};

export default AssignTeacherModalContainer;
